<main (checkoutKonami)="konami()" class="main-content is-fullwidth" id="checkout">
    <ng-container #modal></ng-container>
    <div [ngClass]="{ 'is-hidden': (showSkeleton$ | async) }">
        <section class="section has-background-white">
            <div class="column">
                <h1 class="title is-level-1">Mon panier</h1>
                <checkout-stepper />
            </div>
        </section>
        <div id="promoBanner"></div>
        <section class="section has-background-grey-fade">
            @if (showBackToStepOneButton) {
                <div class="mb-1 is-moved-up">
                    <button
                        type="button"
                        data-tc-action="Clic_redirection"
                        data-tc-categorie="Sortie_checkout"
                        data-tc-clic="Retour_panier"
                        (click)="goToHome()"
                        class="link button-clear is-moved-up"
                    >
                        Retour au panier
                    </button>
                </div>
            }
            <div class="columns is-multiline is-desktop page-container">
                <div class="column is-8-desktop">
                    <div class="rows">
                        <div class="row">
                            <router-outlet></router-outlet>
                        </div>
                        <div class="row is-hidden-mobile is-hidden-tablet-only">
                            <div class="rows">
                                <div class="row">
                                    <checkout-reinsurance />
                                </div>
                                <div class="row">
                                    <checkout-credit-accordion />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="column is-4-desktop align-ticket"
                    [ngClass]="{
                        'step-panier': currentStep?.ecommerceStep === 'panier',
                        'is-hidden': (showTicket$ | async),
                    }"
                    id="checkout-ticket"
                >
                    <div class="rows">
                        <div class="ticket-container row">
                            <div class="pt-0 column">
                                <checkout-ticket />
                                <checkout-toaster-list />
                            </div>
                        </div>
                        <div class="is-hidden-desktop row">
                            <checkout-reinsurance />
                            <checkout-credit-accordion />
                            <div class="divider has-background-grey-fade"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    @if (showMock) {
        <checkout-mocks-handler />
    }
</main>
